/* @flow */
import React from 'react';
import qs from 'qs';

import Group from 'entities/Group';
import Organization from 'entities/Organization';
import { GroupOrOrgType } from 'groups/lib/groupNavigation';

import NoGroupsView from './NoGroupsView.jsx';

class GroupsIndexHandler extends React.Component {
  static propTypes = {
    defaultGroupOrOrg: GroupOrOrgType,
    location: React.PropTypes.object.isRequired,
  };

  static contextTypes = {
    router: React.PropTypes.object.isRequired,
  };

  componentWillMount() {
    const { router } = this.context;
    const { defaultGroupOrOrg } = this.props;

    // XXX this should be an else condition, but that creates an infinite loop with the redirect in
    // groups view when joining a group. Fix by creating an empty state for GroupView so there is no
    // need to redirect to /classes when joining a group
    const { join, admin, action } = this.props.location.query;

    // Pull out actionData and stringify it in order to pass it through as a query param
    // Yes, this looks silly.  Necessary because query.queryParams doesn't exist
    // Also, qs interprets undefined as an empty string, so need to expressly declare
    const actionData = qs.stringify(qs.parse(this.props.location.query).queryParams) || undefined;

    if (defaultGroupOrOrg instanceof Group) {
      router.replace({
        pathname: `/classes/${defaultGroupOrOrg.getCode()}`,
        query: { join, admin, action, actionData },
      });
    } else if (defaultGroupOrOrg instanceof Organization) {
      router.replace({
        pathname: `/organizations/${defaultGroupOrOrg.id}`,
        query: { join, admin, action, actionData },
      });
    }
  }

  render() {
    return <NoGroupsView />;
  }
}

export default GroupsIndexHandler;



// WEBPACK FOOTER //
// ./src/groups/components/GroupsIndexHandler.jsx